export enum eFilters {
  ACTIVE = 'Activos',
  ARCHIVE = 'Archivados',
  ASSIGNED_TO_ME = 'Asignados a mí',
}
